import { Box } from '@mui/material';
import logo from '@assets/img/logo.svg';

function ErrorComponent() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                p: 5,
                animation: 'fadeInOut 2s infinite',
            }}
        >
            <img
                width={size}
                src={logo}
                alt="loading"
                style={{
                    filter: 'brightness(0) saturate(100%) invert(0%) sepia(100%) saturate(7489%) hue-rotate(0deg) brightness(100%) contrast(100%)',
                }}
            />
        </Box>
    );
}

export default ErrorComponent;
